export type RoundingTypes =
  | 'ToEven'
  | 'AwayFromZero'
  | 'ToZero'
  | 'ToNegativeInfinity'
  | 'ToPositiveInfinity';
